import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable, EventEmitter } from "@angular/core";
import { CookieService } from 'ngx-cookie';
import { Observable } from "rxjs/Observable";
import { HttpTokenService } from '../ecare-parent/services/http_token_service';
import { EcareSecurityService } from '../ecare-parent/services/ecare_security_service';

/**
This script works as a guard for any request from UI and checks if user has a valid token 
to access resource server , if not it tries with refresh token to get a fresh token or else
logs out user.
**/
@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private tokenService: HttpTokenService, private cookieService: CookieService,
  private securityService: EcareSecurityService) {
  }

  private redirectToLoginPage() {
    this.router.navigate(['/login']);
  }

  private sendResult(result: boolean, obs: EventEmitter<boolean>): void {
    obs.emit(result);
    if (!result) {
      this.redirectToLoginPage();
    }
    obs.complete();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let obs: EventEmitter<boolean> = new EventEmitter<boolean>();
    this.tokenService.check_token()
            .subscribe(
              response => {
                if (response != null && localStorage.getItem('clientId') !== '') {
                  this.sendResult(true, obs);
                }
                else {
                  this.sendResult(false, obs);
                }
              },
              err => {
                if(err.json().error === 'invalid_token'){
                  this.tokenService.obtainAccessTokenWithRefreshToken()
                          .subscribe(
                              response => {
                                if (response != null && this.securityService.getClientId() !== '') {
                                  this.tokenService.saveToken(response);
                                  this.sendResult(true, obs);
                                }
                                else {
                                  console.log('Login error!');
                                  this.sendResult(false, obs);
                                }
                              },
                              err => {
                                this.sendResult(false, obs);
                                console.log('Login error!');
                              }
                            ); 
                }else{
                    console.log('Other login error!');
                }
              });   
     return obs;
   }
}
